/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Login

Properties:
  accessToken: string (required), minLength: 1
*/

var Login = (function () {
  function validateLogin (arg) {
    // Validate accessToken
    if (!arg.accessToken) {
      throw new Error('Login.accessToken: Missing property')
    }
    if (arg.accessToken && !(typeof arg.accessToken === 'string')) {
      throw new Error('Login.accessToken: Wrong type: Got \'' + (typeof arg.accessToken) + '\', but expected: \'string\'')
    }
    if (arg.accessToken && !(arg.accessToken.length >= 1)) {
      throw new Error('Login.accessToken: Minimum length 1, but got: ' + arg.accessToken.length)
    }
  }
  function buildLogin (arg) {
    var Login = arg
    // Complete accessToken
    // Expected Type: string
    Login.accessToken = Login.accessToken || ''
    return Login
  }
  return {
    validate: validateLogin,
    build: buildLogin
  }
})()

module.exports = Login
